<template lang='pug'>
//- SideEffect-Translator
div(:class='$style[`cc-side-effect-translator`]')
  //- div(v-if='subscribeVip !== `yes`' :class='$style[`cc-side-effect-translator-wrap`]')
  //-   div(:class='$style[`cc-side-effect-translator-tutorial`]')
  //-     div(:class='$style[`cc-side-effect-translator-tutorial-wrap`]')
  //-       figure(:class='$style[`cc-side-effect-translator-tutorial-graphic`]')
  //-         img(:src='`${STATIC_URL}images/subscribe/expire.webp`' width='100%')
  //-       span.font-medium 本服務、內容為VIP會員限定，請先訂閱。
  //-       router-link.btn-extra.font-medium(
  //-         title='升級VIP會員'
  //-         tabindex='0' aria-label='升級VIP會員'
  //-         :to='`/shop/subscribe`'
  //-         :class='$style[`cc-side-effect-translator-tutorial-close`]') 立即訂閱

  //- 狀態列
  div(:class='$style[`cc-side-effect-translator-wrap`]')
    div(v-if='subscribeVip !== `yes`' :class='$style[`cc-side-effect-translator-main`]')
      div(:class='$style[`cc-side-effect-translator-tutorial`]')
        div(:class='$style[`cc-side-effect-translator-tutorial-wrap`]')
          figure(:class='$style[`cc-side-effect-translator-tutorial-graphic`]')
            img(:src='`${STATIC_URL}images/subscribe/expire.webp`' width='100%')
          span.font-medium 本功能為VIP會員限定，請先訂閱。
          router-link.btn-extra.font-medium(
            title='升級VIP會員'
            tabindex='0' aria-label='升級VIP會員'
            :to='`/shop/subscribe`'
            :class='$style[`cc-side-effect-translator-tutorial-close`]') 立即訂閱

    div(v-else :class='$style[`cc-side-effect-translator-main`]')
      header(:class='$style[`cc-side-effect-translator-title`]')
        //- span.font-medium(:class='$style[`cc-side-effect-translator-title-text`]') 貼上原報告內容(健康存摺)
        //- span(:class='$style[`cc-side-effect-translator-title-lang`]') 翻譯成 繁體中文
        span.font-medium(:class='$style[`cc-side-effect-translator-title-text`]') 請提供翻譯來源
        span(:class='$style[`cc-side-effect-translator-title-lang`]') 僅支援: 英文 > 繁體中文

      //- header(:class='$style[`cc-side-effect-translator-step1-title`]')
      //-   span.font-medium(:class='$style[`cc-side-effect-translator-title-text`]') 貼上原報告內容(健康存摺)
      //-   span(:class='$style[`cc-side-effect-translator-title-lang`]') 翻譯成 繁體中文
        //- figure(:class='$style[`cc-side-effect-translator-chatgpt`]')
        //-   img(:src='`${STATIC_URL}images/sideeffect/chatgpt.webp`' width='100%')

      //- div(:class='$style[`cc-side-effect-translator-notice`]')
      //-   ul(:class='$style[`cc-side-effect-translator-notice-ul`]')
      //-     li(:class='$style[`cc-side-effect-translator-notice-li`]') * 看不懂健康存摺的診斷報告？本功能提供完整翻譯內容、重點解說。
      //-     li(:class='$style[`cc-side-effect-translator-notice-li`]') * 原文僅支援「英文」，每次翻譯限 {{ strLimit }} 字內。
        //- button.font-medium(
        //-   tabindex='0' aria-label='C幣是什麼？'
        //-   :class='$style[`cc-side-effect-userPost-coin`]'
        //-   @click='handleClickToShowPointTutorial(`point`)')
        //-   IconCcoin(:size='22')
        //-   span 幣是什麼？

      div(v-if='!sourceOrigin && !errorDetect' :class='$style[`cc-side-effect-translator-step1`]')
        div(:class='$style[`cc-side-effect-translator-step1-selector`]')
          //- 上傳截圖照片
          button(
            tabindex='0' aria-label='選擇上傳截圖照片'
            :class='$style[`cc-side-effect-translator-step1-upload`]'
            @click='sourceOrigin = `upload`')
            div(:class='$style[`cc-side-effect-translator-selector-icon`]')
              IconAttachFile(:size='40' :color='`#262626`')
            div(:class='$style[`cc-side-effect-translator-selector-title`]')
              span.font-bold(:class='$style[`cc-side-effect-translator-selector-title-text`]') 上傳截圖照片
              span.font-medium(:class='$style[`cc-side-effect-translator-selector-title-sub-text`]') (健康存摺報告截圖)

          span(:class='$style[`cc-side-effect-translator-step1-or`]') 或

          //- 複製貼上文字
          button(
            tabindex='0' aria-label='選擇複製貼上文字'
            :class='$style[`cc-side-effect-translator-step1-paste`]'
            @click='sourceOrigin = `text`')
            div(:class='$style[`cc-side-effect-translator-selector-icon`]')
              IconDuplicate(:size='40' :color='`#262626`')
            div(:class='$style[`cc-side-effect-translator-selector-title`]')
              span.font-bold(:class='$style[`cc-side-effect-translator-selector-title-text`]') 複製貼上文字
              span.font-medium(:class='$style[`cc-side-effect-translator-selector-title-sub-text`]') (健康存摺報告內容)

      div(v-else-if='sourceOrigin && !errorDetect' :class='$style[`cc-side-effect-translator-step2`]')
        div(v-if='sourceOrigin === `upload`' :class='$style[`cc-side-effect-translator-uploader`]')
          ul(:class='$style[`cc-side-effect-translator-uploader-tutorial`]')
            li(:class='$style[`cc-side-effect-translator-uploader-tutorial-list`]') 支援類型: 診斷報告、影像檢查、抽血驗尿、檢驗指數。單次最多上傳三張截圖，重複的內容會自動合併。
            //- li(:class='$style[`cc-side-effect-translator-uploader-tutorial-list`]') 支援類型: 診斷報告、影像檢查、抽血驗尿、檢驗指數。

          div(:class='$style[`cc-side-effect-translator-uploader-btn`]')
            div(v-if='formConfig.photoScan1Src' :class='$style[`cc-uploader-area`]')
              button(
                tabindex='0'
                aria-label='移除圖片'
                :class='$style[`cc-uploader-delete-btn`]' @click='formConfig.photoScan1 = null; formConfig.photoScan1Src = ``')
                IconDelete(:size='16' :color='`#b1b1b1`')
                span 移除
              img(:src='formConfig.photoScan1Src' width='100%')
            div(v-else :class='[$style[`cc-uploader-area`], $style[formVerify.photoScan1Error ? `cc-uploader-error` : ``]]')
              input(
                type='file'
                ref='photo1'
                name='photo1'
                :class='$style[`cc-uploader-inputer`]'
                @change='handlePhotoScanUpload(1)')
              div(:class='$style[`cc-uploader-interface`]')
                IconUpload(:size='40' :color='`#dcdcdc`')
                span(v-if='formVerify.photoScan1Error' :class='$style[`cc-uploader-tip-error`]') {{ formVerify.showPhoto1ErrorTips }}
                span(v-else :class='$style[`cc-uploader-tip`]') 上傳截圖


            div(v-if='formConfig.photoScan2Src' :class='$style[`cc-uploader-area`]')
              button(
                tabindex='0'
                aria-label='移除圖片'
                :class='$style[`cc-uploader-delete-btn`]' @click='formConfig.photoScan2 = null; formConfig.photoScan2Src = ``')
                IconDelete(:size='16' :color='`#b1b1b1`')
                span 移除
              img(:src='formConfig.photoScan2Src' width='100%')
            div(v-else :class='[$style[`cc-uploader-area`], $style[formVerify.photoScan2Error ? `cc-uploader-error` : ``]]')
              input(
                type='file'
                ref='photo2'
                name='photo2'
                :class='$style[`cc-uploader-inputer`]'
                @change='handlePhotoScanUpload(2)')
              div(:class='$style[`cc-uploader-interface`]')
                IconUpload(:size='40' :color='`#dcdcdc`')
                span(v-if='formVerify.photoScan2Error' :class='$style[`cc-uploader-tip-error`]') {{ formVerify.showPhoto2ErrorTips }}
                span(v-else :class='$style[`cc-uploader-tip`]') 上傳截圖


            div(v-if='formConfig.photoScan3Src' :class='$style[`cc-uploader-area`]')
              button(
                tabindex='0'
                aria-label='移除圖片'
                :class='$style[`cc-uploader-delete-btn`]' @click='formConfig.photoScan3 = null; formConfig.photoScan3Src = ``')
                IconDelete(:size='16' :color='`#b1b1b1`')
                span 移除
              img(:src='formConfig.photoScan3Src' width='100%')
            div(v-else :class='[$style[`cc-uploader-area`], $style[formVerify.photoScan3Error ? `cc-uploader-error` : ``]]')
              input(
                type='file'
                ref='photo3'
                name='photo3'
                :class='$style[`cc-uploader-inputer`]'
                @change='handlePhotoScanUpload(3)')
              div(:class='$style[`cc-uploader-interface`]')
                IconUpload(:size='40' :color='`#dcdcdc`')
                span(v-if='formVerify.photoScan3Error' :class='$style[`cc-uploader-tip-error`]') {{ formVerify.showPhoto3ErrorTips }}
                span(v-else :class='$style[`cc-uploader-tip`]') 上傳截圖



          div(:class='$style[`cc-side-effect-translator-form-control`]')
            div(:class='$style[`cc-side-effect-translator-form-control-left`]')
              button(
                title='返回'
                tabindex='0' aria-label='返回'
                :class='$style[`cc-side-effect-translator-controller-return`]'
                @click='resetSourceOrigin')
                IconOpenArrow(:size='20' :color='`#262626`')
                != '返回'

              button.btn-normal-extra(
                title='開始翻譯'
                tabindex='0' aria-label='開始翻譯'
                :class='[$style[`cc-side-effect-translator-controller-send`], $style[formConfig.photoScan1Src || formConfig.photoScan2Src || formConfig.photoScan3Src ? `` : `disabled`]]'
                @click='debounceStartTranslation') 開始翻譯



        div(v-if='sourceOrigin === `text`' :class='$style[`cc-side-effect-translator-form`]')
          //- 已訂閱服務
          div(:class='$style[`cc-side-effect-translator-form-wrap`]')
            //- div(:class='$style[`cc-side-effect-translator-form-interactive`]')
            //-   div(:class='$style[`cc-side-effect-translator-form-language`]')
            //-     span(:class='$style[`cc-side-effect-translator-form-language-title`]') 翻譯成
            //-     SelectModel(
            //-       v-model='formConfig.lang'
            //-       title='翻譯的語言'
            //-       style='width: 110px'
            //-       :class='$style[`cc-select-area`]'
            //-       :placehold='`選擇語言`'
            //-       :optionList='[`繁體中文`]'
            //-       :errorValue='formVerify.langError'
            //-       :defaultValue='formConfig.lang'
            //-       @clearErrorMsg="(value) => {this.formVerify.langError = value}")
            //-   div(:class='$style[`cc-side-effect-translator-form-count`]')
            //-     span 花費
            //-     div(:class='$style[`cc-shop-effect-translator-cost-coin`]')
            //-       IconCcoin(:size='22')
            //-       span.font-bold 10

            div(:class='$style[`cc-side-effect-translator-form-inserter`]')
              span(v-if='formVerify.insertError' :class='$style[`alertTips`]') {{ formVerify.insertErrorLog }}
              textarea(
                ref='translator'
                v-model='checkInsertStringLimit'
                v-autosize='formConfig.insert'
                placeholder='貼上翻譯的文字內容'
                :class='[$style[`cc-textarea-area`], $style[formVerify.insertError ? `alertBorder` : ``]]'
                @input='onTextAreaChange($event.target.value)')

          div(:class='$style[`cc-side-effect-translator-form-control`]')
            div(:class='$style[`cc-side-effect-translator-form-control-left`]')
              button(
                title='返回'
                tabindex='0' aria-label='返回'
                :class='$style[`cc-side-effect-translator-controller-return`]'
                @click='resetSourceOrigin')
                IconOpenArrow(:size='20' :color='`#262626`')
                != '返回'

              button.btn-normal-extra(
                title='開始翻譯'
                tabindex='0' aria-label='開始翻譯'
                :class='[$style[`cc-side-effect-translator-controller-send`], $style[!formConfig.insert ? `disabled` : ``]]'
                @click='debounceStartTranslation') 開始翻譯

              button(
                title='清除'
                tabindex='0' aria-label='清除'
                :class='$style[`cc-side-effect-translator-controller-reset`]'
                @click='handleClickCleanTextArea') 清除


            div(:class='$style[`cc-side-effect-translator-form-control-right`]')
              div(:class='[$style[`cc-side-effect-translator-form-control-limit`], $style[formConfig.insert.length >= strLimit ? `alertTips` : ``]]') {{ formConfig.insert.length + '/' + strLimit }} 字

      div(v-else :class='$style[`cc-side-effect-translator-error`]')
        span(:class='$style[`cc-side-effect-translator-error-text`]') Ai連線已關閉，無法翻譯。

    div(v-if='historyTranslation.length' :class='$style[`cc-side-effect-translator-history`]')
      header(:class='$style[`cc-side-effect-translator-title`]')
        span.font-bold 我的翻譯紀錄

      div(v-if='preloading' :class='$style[`cc-side-effect-translator-loader`]')
        div(:class='$style[`cc-side-effect-translator-loader-icon`]')
          IconLoading(:size='30' :color='`#b1b1b1`')

      ul(v-else :class='$style[`cc-side-effect-translator-history-ul`]')
        li(v-for='items, index in historyTranslation' :key='index' :class='$style[`cc-side-effect-translator-history-li`]')
          div(:class='$style[`cc-side-effect-translator-history-item`]')
            span.font-medium(:class='$style[`cc-side-effect-translator-history-item-date`]') {{ items.date }}
            span.font-medium(:class='$style[`cc-side-effect-translator-history-item-short`]') {{ items.short }}
          div(:class='$style[`cc-side-effect-translator-history-control`]')
            button(
              title='移除'
              tabindex='0' aria-label='移除'
              :class='$style[`cc-side-effect-translator-item-btn`]'
              @click='handleDeleteTranslation(items.id, index)')
              IconTrash(:size='18' :color='`#98a1a1`')
            button(
              title='查看'
              tabindex='0' aria-label='查看'
              :class='$style[`cc-side-effect-translator-item-btn`]'
              @click='handleShowTranslationDetail(items, index)')
              IconSearch(:size='18' :color='`#98a1a1`')

      //- LazyLoad
      infinite-loading(:identifier='infiniteId' @infinite='infiniteHandler')
        div(slot='spinner')
          IconLoading(
            slot='spinner'
            :size='30'
            :color='`#b1b1b1`')
        div.infinite-scroll-slot(slot='no-more' style='padding-top: 15px;')
          span.infinite-scroll-slot-noMore 沒有更多資料
        div.infinite-scroll-slot(slot='no-results' style='padding-top: 15px;')
          span.infinite-scroll-slot-noMore 沒有更多資料


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { debounce } from 'debounce';
import moment from 'moment';

// import SelectModel from '../common/SelectModel';
// import IconClose from '../../icon/Close';
import IconLoading from '../../icon/Loading';
// import IconCcoin from '../../icon/Ccoin';
import IconTrash from '../../icon/Trash';
import IconSearch from '../../icon/Search';
import IconDuplicate from '../../icon/Duplicate';
import IconAttachFile from '../../icon/AttachFile';
import IconOpenArrow from '../../icon/OpenArrow';
import IconUpload from '../../icon/Upload';
import IconDelete from '../../icon/Delete';

import GlobalEmitter from 'tiny-emitter/instance';

import {
  postReportTranslator,
  postReportUploadTranslator,
  putLoadTranslatorResult,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '報告翻譯',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/sideeffect/translator',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/sideeffect/translator',
      }],
    };
  },

  components: {
    // SelectModel,
    // IconCcoin,
    IconLoading,
    IconTrash,
    IconSearch,
    IconDuplicate,
    IconAttachFile,
    IconOpenArrow,
    IconUpload,
    IconDelete,
  },

  data() {
    return {
      preloading: true,
      errorDetect: false,

      sourceOrigin: '', // photo，text

      strLimit: 5000,
      pageSize: 12,
      pageIndex: 1,

      wsRoom: null,

      formConfig: {
        lang: '繁體中文',
        insert: '',
        photoScan1: null,
        photoScan1Src: '',
        photoScan2: null,
        photoScan2Src: '',
        photoScan3: null,
        photoScan3Src: '',
      },
      formVerify: {
        langError: false,
        insertError: false,
        insertErrorLog: '',
        photoScan1Error: false,
        photoScan2Error: false,
        photoScan3Error: false,

        showPhoto1ErrorTips: '',
        showPhoto2ErrorTips: '',
        showPhoto3ErrorTips: '',
      },

      historyTranslation: [],
      verifyAllPass: true,

      abortController: new AbortController(),
      infiniteId: new Date(),
    };
  },

  created() {
    this.axiosLoadUserTranslation();
    this.detectGlobalEmitter();
    // this.initRoomWebsocket();
  },

  beforeDestroy() {
    this.abortController.abort();
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopProgressStatus: 'global/POPPROGRESS_STATUS',
      changePopTranslatorStatus: 'global/POPTRANSLATOR_STATUS',
      changePopDeleteTranslationStatus: 'global/POPDELETE_TRANSLATION_STATUS',
      // updateUserCurrentPoint: 'user/TOPBAR_USER_UPDATE_POINT',
      // updateUserTranslateCredit: 'user/USER_UPDATE_TRANSLATE_CREDIT',
    }),

    infiniteHandler($state) {
      if (!this.preloading) {
        // const jwtAccess = JSON.parse(this.authJwtToken).a;

        const USER_CONFIG = {
          auth_id: this.loginDjangoId,
          page: this.pageIndex,
          size: this.pageSize
        };

        putLoadTranslatorResult('', USER_CONFIG, {})
          .then((res) => {
            res.data.results.map((x) => this.historyTranslation.push(x));
            console.log('LazyLoad ok', this.historyTranslation);

            if (res.data.results.length < this.pageSize || this.historyTranslation.length === res.data.count) {
              $state.complete();
            } else {
              this.pageIndex += 1;
            }
            $state.loaded();
          })
          .catch((err) => {})
      } else {
        $state.complete();
      }
    },

    detectGlobalEmitter() {
      let vm = this;
      if (vm.historyTranslation) {

        GlobalEmitter.on('create-translation', function (arg) {
          console.log('GlobalEmitter Create', arg);
          vm.historyTranslation.unshift(arg);
          vm.resetSourceOrigin();
        });

        GlobalEmitter.on('update-translation', function (arg) {
          console.log('GlobalEmitter Update', arg);
          vm.historyTranslation[arg.index].short = arg.short;
        });

        GlobalEmitter.on('delete-translation', function (arg) {
          console.log('GlobalEmitter Delete', arg);
          vm.historyTranslation.splice(arg, 1);
        });
      }
    },

    resetSourceOrigin() {
      this.sourceOrigin = '';
      this.formConfig = this.$options.data().formConfig;
      this.formVerify = this.$options.data().formVerify;
    },

    onTextAreaChange(value) {
      console.log('EEE', this.$refs.translator.value, this.formConfig.insert);
      this.$refs.translator.value = value;
    },

    handleClickCleanTextArea() {
      this.formVerify.insertError = false,
      this.formVerify.insertErrorLog = '',
      this.$refs.translator.value = '';
      this.formConfig.insert = ''
    },

    // handleEmitterCleanTextArea(vm) {
    //   vm.formVerify.insertError = false,
    //   vm.formVerify.insertErrorLog = '',
    //   vm.$refs.translator.value = '';
    //   vm.formConfig.insert = ''
    // },

    handleDeleteTranslation(pk, index) {
      console.log('handleDeleteTranslation', pk, index);
      this.changePopDeleteTranslationStatus({
        active: true,
        id: pk,
        forId: index
      });
    },

    handlePhotoScanUpload(index) {
      this.formVerify[`photoScan${index}Error`] = false;

      const uploadProcess = new Promise((resolve) => {
        const photoFile = this.$refs[`photo${index}`].files;
        // this.showUploadErrorMsg = false;
        // this.cmuConfig.photoBreakfast = photoFile;
        return resolve(photoFile);
      });

      uploadProcess.then((value) => {
        const file = value[0];
        if (file.type === '' || file.type === 'image/jpeg' || file.type === 'image/png') {
          const vm = this;
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.src = _URL.createObjectURL(file);

          img.onload = function () {
            if (file.size > (6000 * 1024)) {
              vm.formVerify[`photoScan${index}Error`] = true;
              vm.formVerify[`showPhoto${index}ErrorTips`] = '檔案過大，需小於6MB';
            } else {
              vm.formConfig[`photoScan${index}`] = file;
              vm.formConfig[`photoScan${index}Src`] = img.src;
            }
          };
        } else {
          this.formVerify[`photoScan${index}Error`] = true;
          this.formVerify[`showPhoto${index}ErrorTips`] = '僅支援圖片格式';
          console.log('ERROR DATA TYPE', this.formVerify[`photoScan${index}Error`])
        }
      })
    },

    handleShowTranslationDetail(data, index) {
      console.log('DATA', data);
      this.changePopTranslatorStatus({
        active: true,
        detail: {
          index,
          feature: 'edit', // edit
          id: data.id,
          language: data.language,
          date: data.date,
          short: data.short,
          // suggestion: data.completion,
          origin: data.origin,
          completion: data.completion,
        },
      });
    },

    axiosLoadUserTranslation() {
      this.historyTranslation = [];

      const USER_CONFIG = {
        auth_id: this.loginDjangoId,
        page: this.pageIndex,
        size: this.pageSize
      };

      putLoadTranslatorResult('', USER_CONFIG, {})
        .then((res) => {
          if (!res.data.count) {
            console.log('load empty', res.data);
          } else {
            this.historyTranslation = res.data.results;
            this.pageIndex += 1;
          }
          this.preloading = false;
          this.infiniteId += 1;
        })
        // .catch((err) => {})
    },

    axiosOpenAiTranslate() {
      if (!this.verifyAllPass) { return; }

      this.changePopProgressStatus({
        active: true,
        feature: 'translate',
      });

      const translateProcess = new Promise((resolve) => {
        let translateLang = '';

        switch (this.formConfig.lang) {
          case '繁體中文':
            translateLang = 'Traditional Chinese';
            break;
          // case '簡體中文':
          //   translateLang = 'Chinese';
          //   break;
          case '日文':
            translateLang = 'Japanese';
            break;
          default:
            translateLang = 'Traditional Chinese';
            break;
        }
        return resolve(translateLang);
      });

      translateProcess.then((value) => {
        if (this.sourceOrigin === 'text') {
          const POST_DATA = {
            auth_id: `${this.loginDjangoId}`,
            user_type: this.loginProfile.user_type,
            room: `0-${this.loginHashCode}-${this.loginDjangoId}`,
            input_content: this.formConfig.insert,
            feature: 'translate',
            language: value
          };
  
          console.log('translateProcess', POST_DATA);
          
          postReportTranslator('', POST_DATA, {signal: this.abortController.signal})
            .then((res) => {
              console.log('postReportTranslator Success', res.data);
            })
            .catch((err) => {
              console.log('postReportTranslator Error', err);
            })
        } else {

          const formData = new FormData();

          formData.append('auth_id', `${this.loginDjangoId}`);
          formData.append('user_type', this.loginProfile.user_type);
          formData.append('room', `0-${this.loginHashCode}-${this.loginDjangoId}`);
          formData.append('feature', 'photo_translate');
          formData.append('language', value);

          // const POST_DATA = {
          //   auth_id: `${this.loginDjangoId}`,
          //   user_type: this.loginProfile.user_type,
          //   room: `0-${this.loginHashCode}-${this.loginDjangoId}`,
          //   photo_upload: this.formConfig.insert,
          //   feature: 'photo_translate',
          //   language: value
          // };

          const currentTimeStamp = moment().unix();
          console.log('currentTimeStamp', currentTimeStamp);

          if (this.formConfig.photoScan1) {
            const fileType = this.formConfig.photoScan1.type === 'image/jpeg' ? 'jpg' : 'png';
            formData.append('photo_upload', this.formConfig.photoScan1, `translate_${currentTimeStamp}_1.${fileType}`);
          }

          if (this.formConfig.photoScan2) {
            const fileType = this.formConfig.photoScan2.type === 'image/jpeg' ? 'jpg' : 'png';
            formData.append('photo_upload', this.formConfig.photoScan2, `translate_${currentTimeStamp}_2.${fileType}`);
          }

          if (this.formConfig.photoScan3) {
            const fileType = this.formConfig.photoScan3.type === 'image/jpeg' ? 'jpg' : 'png';
            formData.append('photo_upload', this.formConfig.photoScan3, `translate_${currentTimeStamp}_3.${fileType}`);
          }
          
          postReportUploadTranslator('', formData, {
            signal: this.abortController.signal,
            headers: {
              'content-Type': 'multipart/form-data',
              // Authorization: `Bearer ${jwtAccess}`,
            },
          })
            .then((res) => {
              console.log('postReportUploadTranslator Success', res.data);
            })
            .catch((err) => {
              console.log('postReportUploadTranslator Error', err);
            })
        }
      })

    },

    handleFormsCheckToPass() {
      this.verifyAllPass = true;
      // 內容不是中文
   
      // 驗證角色欄位為空
      if (!this.formConfig.lang) {
        this.formVerify.langError = true;
        this.verifyAllPass = false;
      }

      if (this.formVerify.insertError) {
        this.verifyAllPass = false;
      }
    },

    async handleCheckProgressBeforeTranslate() {
      await this.handleFormsCheckToPass();
      await this.axiosOpenAiTranslate();
    },

    debounceStartTranslation: debounce(async function(e) {
      this.handleCheckProgressBeforeTranslate();
    }, 300),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginHashCode: 'user/exportUserHashCode',
      subscribeVip: 'user/exportUserSubscribeVip',
      loginProfile: 'user/exportUserProfile',
      authJwtToken: 'user/exportUserJwtToken',
      // popTranslator: 'global/exportPopTranslatorStatus',
    }),

    checkInsertStringLimit: {
      get() {
        return this.formConfig.insert;
      },
      set(newValue) {
        this.formVerify.insertError = false;
        this.formVerify.insertErrorLog = '';

        // const regularPattern = new RegExp(/[^\x00-\x7F\s(!$%^&*()_+|~=`{}\[\]:";'<>@?,.\/，。；：！”！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠)]/g);
        const regularPattern = new RegExp(/^\w+$/g);

        if (newValue.match(regularPattern) && newValue.length <= this.strLimit) {
          this.formVerify.insertError = true;
          this.formVerify.insertErrorLog = '原文限英文 / 斷落或句子';
          this.formConfig.insert = newValue;

        } else if (newValue.match(regularPattern) && newValue.length > this.strLimit) {
          this.formVerify.insertError = true;
          this.formVerify.insertErrorLog = '原文限英文 / 超過字數上限';
          this.formConfig.insert = newValue.substring(0, this.strLimit);

        } else if (newValue.length > this.strLimit) {
          this.formVerify.insertError = true;
          this.formVerify.insertErrorLog = '已超過字數上限';
          this.formConfig.insert = newValue.substring(0, this.strLimit);

        } else {
          this.formConfig.insert = newValue;
        }
      } 
    },
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectTranslator.scss';
</style>
